export default __webpack_public_path__ + "static/media/renewable-energy-progress-progress-bar-incremented.5390c192.png";